import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          tracker_settings: {
            tabs: {
              tracker_groups: {
                tab_name: 'TAB_NAME',
                form: {
                  date: 'FORM_DATE',
                  groups: {
                    add_new_group: 'FILTER_ADD_NEW_FILTER',
                    no_group_name: 'FORM_GROUPS_NO_GROUP_NAME',
                    group_name_input_label: 'FORM_GROUPS_NAME_INPUT_LABEL',
                  },
                  enable_use_of_anid2: {
                    label: 'FORM_ENABLE_USE_ANID_LABEL',
                    yes: 'FORM_ENABLE_USE_ANID_YES',
                    no: 'FORM_ENABLE_USE_ANID_NO',
                  },
                },
                modal_window: {
                  remove_group: {
                    title: 'DIALOG_FILTER_TITLE',
                    remove_question: 'DIALOG_FILTER_CONTENT',
                    delete: 'DIALOG_FILTER_YES',
                    cancel: 'DIALOG_FILTER_NO',
                  },
                },
                validations: {
                  invalid_some_group: 'VALIDATIONS_INVALID_SOME_GROUP',
                  tracker_required: 'VALIDATIONS_TRACKER_REQUIRED',
                  group_name_required: 'VALIDATION_GROUP_NAME_REQUIRED',
                },
              },
            },
          },
        },
      },
    },
  }));
}
